<div class="flex flex-col mb-16">
  <div class="mx-auto mb-6 mt-10 flex w-[80%] items-center justify-between">
    <h1 class="text-3xl">Clientes</h1>
  </div>
  <ag-grid-angular
    style="height: 75vh"
    class="ag-theme-quartz mx-auto"
    [rowData]="clientes"
    [columnDefs]="columnDefs"
    [gridOptions]="gridOptions"
  />
</div>
